export const MAX_IMAGE_SIZE = 120; // Max size for the image (640x640 pixels)

export const cropAndResizeImage = async (file: File): Promise<{ resizedFile: File, resizedImageURI: string }> => {
  
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();
  
      reader.onload = (e) => {
        img.src = e.target?.result as string;
      };
  
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
  
        if (!ctx) {
          return reject(new Error('Could not create canvas context'));
        }
  
        // Calculate cropping and scaling
        let width = img.width;
        let height = img.height;
  
        // Calculate scaling to make the smallest side MAX_IMAGE_SIZE
        const scaleFactor = MAX_IMAGE_SIZE / Math.min(width, height);
  
        width = width * scaleFactor;
        height = height * scaleFactor;
  
        // Set canvas size to be the square crop size (MAX_IMAGE_SIZE)
        canvas.width = MAX_IMAGE_SIZE;
        canvas.height = MAX_IMAGE_SIZE;
  
        // Calculate cropping area in the middle of the image
        const cropX = (width - MAX_IMAGE_SIZE) / 2;
        const cropY = (height - MAX_IMAGE_SIZE) / 2;
  
        // Draw the image cropped and resized to MAX_IMAGE_SIZE
        ctx.drawImage(img, -cropX, -cropY, width, height);
  
        canvas.toBlob((blob) => {
          if (blob) {
            const resizedFile = new File([blob], file.name, { type: file.type });
            const resizedImageURI = canvas.toDataURL(file.type);
  
            resolve({ resizedFile, resizedImageURI });
          } else {
            reject(new Error('Image resizing and cropping failed.'));
          }
        }, file.type);
      };
  
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };
  

export const cropAndResizeImageOld = (file: File): Promise<{ resizedFile: File; resizedImageURI: string }> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target?.result as string;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        const originalWidth = img.width;
        const originalHeight = img.height;

        // Calculate the size of the square to crop
        const cropSize = Math.min(originalWidth, originalHeight);

        // Calculate the cropping point (center)
        const cropX = (originalWidth - cropSize) / 2;
        const cropY = (originalHeight - cropSize) / 2;

        // Set canvas size for the final resized image (640x640)
        canvas.width = MAX_IMAGE_SIZE;
        canvas.height = MAX_IMAGE_SIZE;

        // Draw the cropped and resized image on the canvas
        context?.drawImage(
          img, // Source image
          cropX, cropY, cropSize, cropSize, // Crop start x/y and width/height
          0, 0, MAX_IMAGE_SIZE, MAX_IMAGE_SIZE // Draw on the canvas starting at 0,0 to 640x640
        );

        // Convert canvas to base64
        const resizedImageURI = canvas.toDataURL('image/jpeg');

        // Convert the data URI to a file and return
        const resizedFile = dataURItoFile(resizedImageURI, file.name);
        resolve({ resizedFile, resizedImageURI });
      };
      img.onerror = reject;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

// Convert base64/URI to a file
export const dataURItoFile = (dataURI: string, filename: string): File => {
  const byteString = atob(dataURI.split(",")[1]);
  const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([ab], { type: mimeString });
  return new File([blob], filename);
};
